import React, { useEffect, useCallback } from 'react'
import { View } from './View'
import { useOrders } from '../../services/api/orders'
import { defaultPagination } from '../../services/api/client/types'

const STATUS_FAILED = 'failed'
const REQUEST_INTERVAL: number = 30000

export const Container: React.FunctionComponent = ({ children }) => {
  const [getOrders, { isLoading, error, response }] = useOrders()

  const getFailedOrders = useCallback(() => {
    getOrders({
      ...defaultPagination,
      status: [STATUS_FAILED],
    })
  }, [getOrders])

  useEffect(() => {
    getFailedOrders()
    const interval = setInterval(getFailedOrders, REQUEST_INTERVAL)
    return () => clearInterval(interval)
  }, [getFailedOrders])

  const count: number = response?.meta.totalCount || 0
  return (
    <View failedOrders={count} isLoading={isLoading} error={error}>
      {children}
    </View>
  )
}
